<template>
  <b-row class="no-gutters ml-n3">
    <b-col class="col-12 col-md-6 col-lg-4 pl-3">
      <search-input
        v-model="searchInput"
        label="search"
        :placeholder="$t('page.communication.searchPlaceholder')"
        @search="search"
      ></search-input>
    </b-col>
    <b-col class="col-12 col-md-6 col-lg-4 pl-3">
      <form-select v-model="filterCommunicationStatus" label="status">
        <b-form-select-option :value="null">
          {{ $t("all") }}
        </b-form-select-option>
        <b-form-select-option
          v-for="(status, index) in communicationStatusOptions"
          :key="index"
          :value="status"
        >
          {{ $t("page.communication.status." + status) }}
        </b-form-select-option>
      </form-select>
    </b-col>
    <b-col class="col-12 col-md-6 col-lg-4 pl-3">
      <form-select v-model="filterCommunicationCondominium" label="condominium">
        <b-form-select-option :value="null">
          {{ $t("all") }}
        </b-form-select-option>
        <b-form-select-option
          v-for="(condominium, index) in condominiums"
          :key="index"
          :value="condominium._id"
        >
          {{ condominium.name }}
        </b-form-select-option>
      </form-select>
    </b-col>
  </b-row>
</template>

<script>
import SearchInput from "../Base/BaseSearchInput";
import FormSelect from "../Base/BaseFormSelect";
import { SORT_FILTERS } from "./../../Utils";

export default {
  components: {
    SearchInput,
    FormSelect
  },
  data() {
    return {
      searchInput: "",
      communicationStatusOptions: ["pending", "sent"], // "deleted", "suspended",
      condominiumsOptions: []
    };
  },
  mounted() {
    this.searchInput = this.filterSearch;
  },
  computed: {
    condominiums() {
      return SORT_FILTERS(
        this.$store.getters["condominium/getActiveCondominiums"],
        "name"
      );
    },
    filterSearch: {
      get() {
        return this.$store.getters["communication/getFilterSearch"];
      },
      set(value) {
        this.$store.commit("communication/SET_FILTER_SEARCH", value);
      }
    },
    filterCommunicationStatus: {
      get() {
        return this.$store.getters["communication/getFilterStatus"];
      },
      set(value) {
        this.$store.commit("communication/SET_FILTER_STATUS", value);
        this.retrieveCommunications();
      }
    },
    filterCommunicationCondominium: {
      get() {
        return this.$store.getters["communication/getFilterCondominium"];
      },
      set(value) {
        this.$store.commit("communication/SET_FILTER_CONDOMINIUM", value);
        this.retrieveCommunications();
      }
    }
  },
  methods: {
    search() {
      this.filterSearch = this.searchInput;
      this.retrieveCommunications();
    },
    async retrieveCommunications() {
      try {
        this.$store.commit("loader/SET_LOADER", {});
        await this.$store.dispatch("communication/retrieveUserCommunications");
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("loader/RESET");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
